import { useQuery } from "@tanstack/react-query";
import { NotificationsKeys } from "web_myplann/Api/Notifications/notificatioKeys";
import {
	getNotificationsGroupedCountV2,
	type NotificationTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGetNotificationsGroupedCountQuery = (
	filterOnlyunread?: boolean,
	filterExcludetypes?: NotificationTypeEnum[],
	options?: { enabled?: boolean },
) => {
	return useQuery({
		queryKey: NotificationsKeys.groupedCountFiltered(
			filterOnlyunread,
			filterExcludetypes,
		),
		queryFn: processResponse(() =>
			getNotificationsGroupedCountV2(filterOnlyunread, filterExcludetypes),
		),
		enabled: options?.enabled,
	});
};
